﻿import { Directive, ViewContainerRef } from "@angular/core";

@Directive({
  selector: '[bulk-operation-step-host]',
})
export class BulkOperationStepHostDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}